import axios from '@/lib/axios';
import { PurchaseOrderContractTaskDocument } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0890. 発注案件契約タスクファイル登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:purchase_order_contract_task_id/purchase_order_contract_task_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  name: string;
  file?: string;
  url?: string;
};

const createPurchaseOrderContractTaskDocument = (props: Props): Promise<PurchaseOrderContractTaskDocument> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/purchase_order_contract_task_documents`,
    props
  );
};

export const useCreatePurchaseOrderContractTaskDocument = () => {
  return useMutation({
    mutationFn: createPurchaseOrderContractTaskDocument,
  });
};
